import styled from "styled-components";
import { GridContainer } from "../../wrapper/FlexCenter/GridContainter.style";

export const Grid = styled(GridContainer)`
  align-items: center;
  justify-items: center;
`;
